// Client-only, best-effort PostHog wrapper for Schedule Assistant outcome
// events (Find a Session + Schedule Builder). Mirrors the defensive
// $clientPosthog access in find-a-session.vue's captureThumbSurvey: never
// throws, and no-ops when PostHog is absent (consent not yet granted, or SSR).
// Nuxt auto-imports resolve useNuxtApp — no import needed here.
export const useScheduleAnalytics = () => {
    const track = (event, properties = {}) => {
        try {
            useNuxtApp()?.$clientPosthog?.capture?.(event, properties)
        } catch (e) {
            // Telemetry is best-effort — a PostHog failure must never block the UI.
        }
    }

    // The browser's PostHog distinct id, when available. Server-side $ai_* captures
    // are a NO-OP without it, so both SSE endpoints echo it back as `?did=` — if this
    // silently returns '', that flow's LLM telemetry simply never arrives.
    const distinctId = () => {
        try {
            return useNuxtApp()?.$clientPosthog?.get_distinct_id?.() || ''
        } catch (e) {
            return ''
        }
    }

    return { track, distinctId }
}
